import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/site";

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-5 right-5 z-40 sm:bottom-6 sm:right-6"
      data-testid="whatsapp-floating-button"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500 opacity-50 animate-pulse-ring" aria-hidden="true" />
      <span className="relative grid h-14 w-14 place-items-center rounded-full bg-emerald-500 text-white shadow-[0_10px_30px_-6px_rgba(16,185,129,0.6)] transition-transform duration-300 group-hover:scale-110 group-active:scale-95">
        <MessageCircle className="h-7 w-7" />
      </span>
      <span className="pointer-events-none absolute right-16 top-1/2 hidden -translate-y-1/2 whitespace-nowrap rounded-full bg-[#111827] px-3.5 py-2 text-sm font-medium text-white opacity-0 shadow-lg transition-opacity duration-300 group-hover:opacity-100 sm:block">
        Chat on WhatsApp
      </span>
    </a>
  );
}
